import { render, staticRenderFns } from "./TranshipmentBarChart.vue?vue&type=template&id=c0f4da80&scoped=true"
import script from "./TranshipmentBarChart.vue?vue&type=script&lang=js"
export * from "./TranshipmentBarChart.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentBarChart.vue?vue&type=style&index=0&id=c0f4da80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f4da80",
  null
  
)

export default component.exports